import { RootState, useTypedSelector } from 'lib/centralStore';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { ScommesseAccordionFilterPrimary } from 'components/scommesseAccordionFilterPrimary';
import { ScommesseFiltersHeaderSticky } from 'components/scommesseFiltersHeaderSticky';
import { ScommesseFiltersList } from 'components/scommesseFiltersList';
import { ScommesseFiltersMobile } from 'components/scommesseFiltersMobile';
import dynamic from 'next/dynamic';
import { selectListTitlesResults } from 'features/ippica/selectors';
import { setScommesseType } from 'features/ippica/ippicaSlice';
import styles from './IppicaTipiScommessaRendererResults.module.scss';
import { useRouter } from 'next/router';
import useWindowSize from 'hooks/useWindowSize';

export const DynamicIppicaTipiScommessaRendererResults = dynamic(() =>
  import('features/ippica/components/ippicaTipiScommessaRenderer/ippicaTipiScommessaRendererResults').then(
    (mod) => mod.IppicaTipiScommessaRendererResults
  )
);

export const IppicaTipiScommessaRendererResults = () => {
  const route = useRouter().asPath;
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [isModalFiltersOpen, setIsModalFiltersOpen] = useState(false);
  const [isWindowFiltersOpen, setIsWindowFiltersOpen] = useState(false);
  const { isOpen } = useSelector((store: RootState) => store.carrello);

  const list = useTypedSelector(selectListTitlesResults);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setScommesseType(list[selectedIndex]?.title));
  }, [selectedIndex, dispatch, list]);

  useEffect(() => {
    setSelectedIndex(0);
  }, [route]);

  const { isMobile } = useWindowSize();

  if (isMobile) {
    return (
      <>
        <ScommesseFiltersHeaderSticky
          text={'Scegli il risultato'}
          selectedFilter={list[selectedIndex].label}
          secondaryFiltersOpen={isWindowFiltersOpen}
          handleOpenPrimaryFilters={setIsModalFiltersOpen}
        />
        <ScommesseFiltersMobile
          isOpen={isModalFiltersOpen}
          handleClose={setIsModalFiltersOpen}
          text={'Scegli il risultato'}
          btnFooterLabel={'Vedi i risultati'}
        >
          <ScommesseAccordionFilterPrimary
            classNameContainer={`${styles.heightAuto} ${styles.noBorderTopRadius}`}
            isEverythingVisible
            noHeaderVisible
          >
            <ScommesseFiltersList
              onSelectedFilter={(index) => {
                setSelectedIndex(index);
              }}
              removeTitle
              className={styles.noPaddingTop}
              items={list}
              selectedIndex={selectedIndex}
            />
          </ScommesseAccordionFilterPrimary>
        </ScommesseFiltersMobile>
      </>
    );
  }
  return (
    !!list?.length && (
      <div className={`${styles.container} ${isOpen ? styles.noMarginRight : ''}`}>
        <ScommesseAccordionFilterPrimary
          classNameContainer={`${styles.heightAuto} ${styles.noBorderTopRadius}`}
          isEverythingVisible
          noHeaderVisible
        >
          <ScommesseFiltersList
            onSelectedFilter={(index) => {
              setSelectedIndex(index);
            }}
            removeTitle
            className={styles.noPaddingTop}
            items={list}
            selectedIndex={selectedIndex}
          />
        </ScommesseAccordionFilterPrimary>
      </div>
    )
  );
};
